// extracted by mini-css-extract-plugin
export default {"text":"Card_text__Qyg04","container":"Card_container__7VxmM"};